import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect, useContext, createContext } from 'react';
import { jsx } from 'react/jsx-runtime';

var initalState = {
  /** Density for all components inside `EdsProvider` */
  density: 'comfortable'
};
var EdsContext = /*#__PURE__*/createContext(initalState);
var EdsProvider = function EdsProvider(_ref) {
  var children = _ref.children,
    density = _ref.density;
  var _useState = useState(_objectSpread(_objectSpread({}, initalState), {}, {
      density: density || 'comfortable'
    })),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var setDensity = function setDensity(density) {
    return setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        density: density
      });
    });
  };
  useEffect(function () {
    if (typeof density !== 'undefined' && density !== state.density) {
      setDensity(density);
    }
  }, [density, state.density]);
  var value = {
    density: state.density,
    setDensity: setDensity
  };
  return /*#__PURE__*/jsx(EdsContext.Provider, {
    value: value,
    children: children
  });
};
var useEds = function useEds() {
  return useContext(EdsContext);
};

export { EdsProvider, useEds };
